/* --------------------------------------------------------------------------------------
   xwButton.directive.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
 export class xwButton {
  /*@ngInject*/
  constructor () {
    this.restrict = 'A'
    this.scope = {
      disabled: '<'
    }
  }
  link(scope, elem, attrs) {
    let init = false
    const element = elem.first()
    setTimeout(() => {
      element.xrxbutton(getOptions(attrs))
      init = true
    })


    attrs.$observe('label', (val) => {
      if (init)
        element.xrxbutton('option','label', val)
    });

    scope.$watch(scope.disabled, (newVal, oldVal) => {
      //console.log(newVal) //// TODO: set disable option on attr change
    })

    scope.$on('$destroy', () => {
      scope = null
    })
    elem.on('$destroy', () => {
      if (init) {
        element.xrxbutton('destroy')
        elem = null
      }
    })
  }
  static directiveFactory() {
    xwButton.instance = new xwButton()
    return xwButton.instance
  }
}

var getOptions = attrs => {
  return {
    text: !attrs.hasOwnProperty('noText'),
    label: attrs.label,
    widgetSize: attrs.widgetSize,
    width: attrs.width,
    height: attrs.height,
    icons: { glyph: attrs.glyph},
    theme: attrs.theme,
    themePrimary: attrs.themePrimary,
    customClass: attrs.customClass,
    borderless: attrs.borderless
  };
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwButton.directive.js